import Vue from 'vue';
import ConfigPlugin from "./plugins/Config";
import ModalPlugin from "./plugins/Modals";
import RouterPlugin from "./plugins/Router";
import UtilitiesPlugin from "./plugins/Utilities";
import VueMoment from "vue-moment";
import VeeValidate from "vee-validate";
import vClickOutside from "v-click-outside";
import SvgVue from "svg-vue";
import Str from "./helpers/Str";

// Plugins
Vue.use(ConfigPlugin, window.App.config);
Vue.use(RouterPlugin, window.App.routes);
Vue.use(ModalPlugin);
Vue.use(UtilitiesPlugin);
Vue.use(VueMoment);
Vue.use(VeeValidate);
Vue.use(vClickOutside);
Vue.use(SvgVue);

// Filters
Vue.filter("cost", (val) => {
  if (!isNaN(parseFloat(val))) {
    return `$${parseFloat(val).toFixed(2)}`;
  } else {
    return "";
  }
});
Vue.filter("ucwords", (str) => Str.ucwords(str));
Vue.filter("studlyCase", (str) => Str.studlyCase(str));
Vue.filter("camelCase", (str) => Str.camelCase(str));
Vue.filter("slug", (str) => Str.slug(str));
Vue.filter("shorten", (str, length, suffix = "...") => {
  return Str.shorten(str, length, suffix);
});
Vue.filter("strip_tags", (str) => Str.strip_tags(str));
